

var _subscriptionV1Terms = require('./subscriptionV1Terms');

var _subscriptionV1Terms2 = _interopRequireDefault(_subscriptionV1Terms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

module.exports = {
    getFormattedAmount: _subscriptionV1Terms2['default'].getFormattedAmount,
    getTermsText: _subscriptionV1Terms2['default'].getTermsText,
    getNumericValueNonZero: _subscriptionV1Terms2['default'].getNumericValueNonZero,
    isNumericValue: _subscriptionV1Terms2['default'].isNumericValue,
    getTaxDisclaimer: _subscriptionV1Terms2['default'].getTaxDisclaimer
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/subscriptionV1-terms/index.js
// module id = ../node_modules/xo-page-components/src/subscriptionV1-terms/index.js
// module chunks = 0